import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { LocalizedText } from "bernie-l10n";

/**
 * Checks hotel model for freeCancellation or payLater properties
 * and returns an element with the appropriate text
 */
export const ValueProposition = React.memo(({ hotel }: { hotel: Hotel }) => {
  return (
    <div className="ValueProposition uitk-type-300 uitk-flex uitk-flex-column">
      {hotel.freeCancellation && (
        <span>
          <LocalizedText message="hotels.fullyRefundable" />
        </span>
      )}
      {hotel.payLater && (
        <span>
          <LocalizedText message="hotels.reserveNowPayLater" />
        </span>
      )}
    </div>
  );
});
